import { PaymentMethod } from "common/graphql/fragments";

export const getPaymentMethodDisplay = (paymentMethod: PaymentMethod): string => {
  if (paymentMethod.type === "credit_card") {
    return `Card (${paymentMethod.maskedNumber})`;
  } else {
    return "Bank";
  }
};
